// モフトレ通信/月選択画面.
import * as React from 'react';
import * as Header from '../constants/Header';
import UserDetail, { DummyUserDetail } from './common/UserDetail';
import { JS_VOID } from '../utils/commonUtil';
import { MDate, getYearMonthArray } from '../utils/dateUtil';
import * as Enumerable from 'linq';
import '../css/press.css';
import '../css/month_select.css';

interface PressSelectMonthProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;

  // 前ページのユーザーID.
  match?: any;
}

interface PressSelectMonthState {
  date: MDate;
  // 長期変化.
  locomoState: number;
}

// 詳細本体.
export default class PressSelectMonth extends React.Component<PressSelectMonthProps, PressSelectMonthState> {
  cachedUser: any;
  userId: string;

  yearSelected: string;
  // 0埋め2桁.
  monthSelected: string;
  mDate: MDate;

  componentWillMount() {
    document.title = 'モフトレ通信';  

    this.props.headerActions.setPage(Header.PRESS_SELECT_MONTH);

    this.mDate = new MDate();
    this.refresh();

    // URLのパラメータ.
    this.userId = this.props.match.params.userId;
    this.runAPI();
  }

  // 左をクリックしたときの処理.
  minusMonthly = (yearSelected: string, monthSelected: string) => {
    // 先月.
    this.mDate.setPreMonth();
    this.refresh();
    this.runAPI();
  }

  // 右をクリックしたときの処理.
  plusMonthly = (yearSelected: string, monthSelected: string) => {
    // 次の月.
    this.mDate.setNextMonth();
    this.refresh();
    this.runAPI();
  }

  // 範囲内でAPIを叩く.
  runAPI() {
    // Action
    const yearMonthArr: string[] = getYearMonthArray(this.yearSelected, this.monthSelected);
    this.props.moffAPIActions.getMoffTrainingData(this.userId, yearMonthArr);
  }

  refresh = () => {
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
    this.setState({date: this.mDate});
  }

  // ボタンたちを描画.
  renderDispYearMonth(): JSX.Element {
    // key: 2017-08, value: count.
    let dispYearMonth: object = this.props.moffAPI.result.dispYearMonth;
    const cnt: number = Object.keys(dispYearMonth).length;
    if (cnt === 0) {
      return (<p>データがありません。</p>);
    }

    return (
      <div className="button_image">
      {
        // すでに数が0のは選定済み.
        Enumerable.from(dispYearMonth)
        .select<JSX.Element>((element: { key: string; value: any; }, index: number) => {
          return<span key={`pressSelectButton${index}`}>
            <a
              href={`/press/${this.userId}/${element.key}`}
              
              className={index % 2 === 0 ? 'month_grey' : 'month_white'}
              target="_blank"
            >
              <span key={`pressSelectYearMonth${index}`}>{element.key}</span>
            </a>
          </span>;
        }).toArray()
      }
      </div>
    );
  }

  render() {
    return (
      <div>
        <style type="text/css">
          {'a:link, a:visited, a:active {color:#000;text-decoration:none;}'}
        </style>
        {
          (() => {
            if (this.props.moffAPI.Loaded) {
              // キャッシュさせておく.
              if (this.props.moffAPI.result.user) {
                // this.cachedUser = this.props.moffAPI.result;
                this.cachedUser = this.props.moffAPI.result.user;
              }

              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        <article className="report">
          {(this.props.moffAPI.Loaded || this.cachedUser) ? 
            // ロードしたUserを表示
            // ロードした利用者の詳細
            <UserDetail user={this.props.moffAPI.result.user || this.cachedUser} /> 
            :
            <DummyUserDetail />
          }
          <section id="sec02">
            <h2 className="ttlStyle01">モフトレ通信を表示する月を選んで下さい</h2>
            <div className="inner">
              <div className="calendarHeader">
                <div className="dateArea">
                  <div className="date">
                    {this.yearSelected}<span className="year">年</span>{this.monthSelected}<span>月までの1年分を表示</span>
                  </div>
                  <div className="btn left">
                    <a href={JS_VOID} onClick={event => this.minusMonthly(this.yearSelected, this.monthSelected)} />
                  </div>
                  <div className="btn right">
                    <a href={JS_VOID} onClick={event => this.plusMonthly(this.yearSelected, this.monthSelected)} />
                  </div>
                </div>
              </div>
              { // データ数でのif
                (() => {
                  if (this.props.moffAPI.Loading) {
                    return <div><p>読み込み中</p></div>;
                  } else if (this.props.moffAPI.Loaded) {
                    return this.renderDispYearMonth();
                  } else {
                    return (null);
                  }
                })()
              }
            </div>
          </section>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PressSelectMonth.tsx